import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { FormFieldComponent, InputFieldDirective, InputFieldErrorDirective, InputLabelDirective } from "./form-field";
import { INPUT_CONTAINER_DIRECTIVES } from "./input-container/index";
import { SELECT_DIRECTIVES } from "./select/index";

@NgModule({
	imports: [CommonModule],
	declarations: [
		SELECT_DIRECTIVES,
		INPUT_CONTAINER_DIRECTIVES,
		FormFieldComponent,
		InputFieldDirective,
		InputLabelDirective,
		InputFieldErrorDirective,
	],
	exports: [
		SELECT_DIRECTIVES,
		INPUT_CONTAINER_DIRECTIVES,
		FormFieldComponent,
		InputFieldDirective,
		InputLabelDirective,
		InputFieldErrorDirective,
	],
})
export class IcFormsModule {}
